// src/components/navigation/index.js
import React, { Component } from 'react'
import classnames from 'classnames'
import ViewToggle from '../view-toggle'
import { Route } from 'react-router-dom'
import AppLink from '../app-link'
import { navigateUp } from '../../lib/historyUtil'
import './navigation.css'

class Navigation extends Component {

  getListClassNames(item, overArtists, pathname) {
    return classnames({
      'navigation__listitem--active': overArtists && item.get('id') === 'artists',
      'navigation__listitem--inactive': overArtists && item.get('id') === 'info',
      'navigation__listitem--info': pathname.indexOf('contact') >= 0
    }, 'navigation__listitem', 'text--small')
  }

  getListLinkClassNames(item, overArtists, pathname) {
    return classnames({
      'navigation__listitem-link--active': overArtists && item.get('id') === 'artists'
    }, 'navigation__listitem-link')
  }

  getList(menu) {
    const { overArtists, hideArtists, history } = this.props 
    const { location } = history 
    const { pathname } = location

    return menu.map(item => (
      <li className={this.getListClassNames(item, overArtists, pathname)} key={item.get('link')}>
        <AppLink className={this.getListLinkClassNames(item, overArtists  || hideArtists, pathname)} onClick={this.handleClick} to={item.get('link')}>{item.get('title')}</AppLink>
      </li>
    ))
  }

  handleClick = e => {
    // Special case for back button 
    // Go back one in history 
    if (e.target.pathname === '/') {
      e.preventDefault() 
      const { match, history } = this.props
      navigateUp(match, history)
    }
  }

  renderList(data) {
    const menuList = this.getList(data)
    return (<ul className="navigation__list">{menuList}</ul>)
  }

  render() {
    const { match, menu, back, transitionActive } = this.props
    const { isExact } = match
    
    const navClassNames = classnames({
      'navigation--transition-active': transitionActive
    }, 'navigation')
    
    return (
      <div className={navClassNames}>
        {isExact ? this.renderList(menu) : this.renderList(back)} 
        <Route component={ViewToggle} exact path="/" />
        <Route component={ViewToggle} path="/collections/:id" />
        <Route component={ViewToggle} path="/artists/:id" />     
      </div>
    )
  }
}

export default Navigation



// WEBPACK FOOTER //
// ./src/components/navigation/navigation.js